import { hasPermission } from "@features/rbac/permissions";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_layout/admin/")({
	beforeLoad: async () => {
		throw redirect({
			to: hasPermission("timetables.manage")
				? "/admin/timetables"
				: "/admin/connected-users",
		});
	},
});
